import React from "react";
import { withRouter } from "react-router";
// import { Link } from "react-router-dom";

import BaseView from "../base-view/BaseView";
// import AssetDetails from "../../components/asset-details/AssetDetails";
import CommonConstants from "../../constants/CommonConstants";
import SearchSidebar from "../../components/search-sidebar/SearchSidebar";
import Grid from "../../components/grid/Grid";
import Loading from "../../components/loading/Loading";
import Thumbnail from "../../components/thumbnail/Thumbnail";
import NuxeoClient from "../../clients/NuxeoClient";
import EventUtils from "../../utils/EventUtils";
import ObjectUtils from "../../utils/ObjectUtils";
import SearchResults from "../../models/SearchResults";

import "./AssetsView.css";

// const ASSET_DETAIL_LINK_FORMATTER = (cell, entry) => (
//   <Link to={AssetsView.getPath({ id: entry.uid })}>{cell}</Link>
// );

const ASSET_THUMBNAIL_FORMATTER = (cell) => <Thumbnail image={cell} />;

const GRID_COLUMNS = [
  {
    displayName: "Title",
    propertyName: "properties.picture:views[0].content.data",
    formatter: ASSET_THUMBNAIL_FORMATTER,
  },
  {
    propertyName: "title",
    // formatter: ASSET_DETAIL_LINK_FORMATTER,
  },
  {
    displayName: "Style Guide",
    propertyName: "properties.public:styleGuideName",
  },

  {
    displayName: "Franchise/Property",
    propertyName: "properties.public:property[0].title",
  },
];

const ASSET_THUMBNAIL_MAPPER = (entry) => {
  let thumbnail;
  try {
    thumbnail =
      entry.properties["picture:views"][CommonConstants.FILE_VIEWS_THUMBNAIL]
        .content.data;
  } catch {
    thumbnail = null;
  }

  return {
    // href: AssetsView.getPath({ id: entry.uid }),
    thumbnail,
    text: entry.title,
  };
};

class AssetsView extends BaseView {
  static VIEW_PATH = "/asset";

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      page: CommonConstants.FILTER_FIRST_PAGE,
      searchTerm: null,
      searchResults: new SearchResults(),
      reportType: "",
    };

    this.activeReponse = null;
    this.isActiveSelected = false;

    this.archiveReponse = null;
    this.isArchivedSelected = false;

    this.loadingtimer = null;

    this._loadMoreSearchResults = this._loadMoreSearchResults.bind(this);
    // this._loadSelectedAsset = this._loadSelectedAsset.bind(this);
    this._handleAddToCart = this._handleAddToCart.bind(this);
    this._reportSelectionResults = this._reportSelectionResults.bind(this);
    this._checkInitActiveResultsLoaded = this._checkInitActiveResultsLoaded.bind(
      this
    );
    this._checkInitArchiveResultsLoaded = this._checkInitArchiveResultsLoaded.bind(
      this
    );
    this._handleInitReportResult = this._handleInitReportResult.bind(this);
  }

  get loading() {
    return this.state.loading;
  }

  set loading(loading) {
    this.setState({ loading: loading });
  }

  get page() {
    return this.state.page;
  }

  set page(page) {
    this.setState({ page: page });
  }

  get searchResults() {
    return this.state.searchResults;
  }

  set searchResults(searchResults) {
    this.setState({ searchResults: searchResults });
  }

  get searchTerm() {
    return this.state.searchTerm;
  }

  set searchTerm(searchTerm) {
    this.setState(
      {
        searchTerm: searchTerm,
        page: CommonConstants.FILTER_FIRST_PAGE,
        searchResults: new SearchResults(),
        // selectedAsset: null,
        assetType: null,
      },
      () => this._loadMoreSearchResults()
    );
  }

  // get selectedAsset() {
  //   return this.state.selectedAsset;
  // }

  // set selectedAsset(selectedAsset) {
  //   this.setState({ selectedAsset: selectedAsset });
  // }

  get assetType() {
    return this.state.assetType;
  }

  set assetType(assetType) {
    this.setState({ assetType: assetType });
  }

  // get selectedReport() {
  //   return this.state.selectedReport;
  // }

  // set selectedReport(selectedReport) {
  //   this.setState({ selectedReport: selectedReport });
  // }

  // get reportType() {
  //   return this.state.reportType;
  // }

  // set reportType(reportType) {
  //   this.setState({ reportType: reportType });
  // }

  componentDidMount() {
    //Load Active and Archive Result initialy
    this._loadActiveResults();
    // this._loadSelectedAsset(this.props.location);
    this._handleClearToCart(); //Clear Cart item when page change
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.props.location.search !== props.location.search) {
      // this._loadSelectedAsset(props.location);
    }
  }

  _handleClearToCart() {
    // Clear the cart item when change page
    EventUtils.raiseEvent("clear-to-cart", { items: [] }, this.props);
  }

  async _reportSelectionResults(event) {
    await this.setState({ selectedReport: true, reportType: event.detail });
    this._searchSidebar._handleClearClick(); //Clear everything before load...

    this._handleInitReportResult();
  }

  _handleInitReportResult() {
    //Clear the time out
    this.clearTimer();

    this.loading = true;
    this._checkInitActiveResultsLoaded();
  }

  clearTimer() {
    if (this.loadingtimer) {
      clearTimeout(this.loadingtimer);
      this.loadingtimer = null;
    }
  }

  _checkInitActiveResultsLoaded() {
    //Again check reponse stored, else show loading
    if (this.activeReponse === null) {
      this.loading = true;
      this.isActiveSelected = true;
    } else {
      //Hereby go, if already Active result stored
      this.loadingtimer = setTimeout(() => {
        this.setState({ loading: false });
      }, 2000);
      this.setState(
        {
          searchResults: new SearchResults(this.activeReponse),
        },
        () =>
          (this._searchSidebar.aggregations = this.state.searchResults.aggregations)
      );
    }
  }

  _checkInitArchiveResultsLoaded() {
    //Again check reponse stored, else show loading
    if (this.archiveReponse === null) {
      this.loading = true;
      this.isArchivedSelected = true;
    } else {
      //Hereby go, if already Archive result stored
      this.loadingtimer = setTimeout(() => {
        this.setState({ loading: false });
      }, 2000);
      this.setState(
        {
          searchResults: new SearchResults(this.archiveReponse),
        },
        () =>
          (this._searchSidebar.aggregations = this.state.searchResults.aggregations)
      );
    }
  }

  _loadActiveResults() {
    const { searchTerm, page } = this.state;

    NuxeoClient.instance()
      .getAssets(page, null, searchTerm)
      .then((response) => {
        response.entries = [];
        this.activeReponse = response;

        if (true) {
          this.isActiveSelected = false;
          this.setState(
            {
              loading: false,
              searchResults: new SearchResults(response),
            },
            () =>
              (this._searchSidebar.aggregations = this.state.searchResults.aggregations)
          );
        }
      })
      .catch(() => {
        window.Materialize.toast("Failed to retrive filters.", 5000);
        this.loading = false;
      });
  }

  _loadMoreSearchResults() {
    const { searchTerm, page, searchResults } = this.state;
    this.loading = true;
    this.props.handleSearchTerm(searchTerm);
    if (ObjectUtils.includesNotBlankProperty(searchTerm)) {
      NuxeoClient.instance()
        .getAssets(page, null, searchTerm)
        .then((response) => {
          this.setState(
            {
              loading: false,
              page: page + 1,
              searchResults: new SearchResults(response, searchResults.entries),
            },
            () =>
              (this._searchSidebar.aggregations = this.state.searchResults.aggregations)
          );
        })
        .catch(() => {
          window.Materialize.toast("Failed to retrive results.", 5000);
          this.loading = false;
        });
    } else {
      // A call just to get the initial aggregations also no search term
      //loading initial results of Active and Archive
      this._handleInitReportResult();
    }
  }

  // _loadSelectedAsset(location) {
  //   const { id } = this.getSearch(location);

  //   if (id) {
  //     this.loading = true;

  //     NuxeoClient.instance()
  //       .getAssetDetail(id)
  //       .then((file) => {
  //         this.selectedAsset = file ? file : null;
  //         this.assetType = file ? file.type : null;
  //         this.loading = false;
  //       })
  //       .catch(() => {
  //         window.Materialize.toast("Failed to retrive asset.", 5000);
  //         this.loading = false;
  //       });
  //   } else {
  //     this.selectedAsset = null;
  //     this.assetType = null;
  //   }
  // }

  _handleAddToCart(event) {
    EventUtils.raiseEvent(
      "add-to-cart",
      {
        items: event.detail.items,
      },
      this.props
    );
  }

  render() {
    // const { loading, searchResults, selectedAsset } = this.state;
    const { loading, searchResults } = this.state;
    return (
      <div>
        {true ? (
          <section className="assets-view">
            <Loading hidden={!loading} />
            <SearchSidebar
              reference={(element) => (this._searchSidebar = element)}
              onSearch={(event) => (this.searchTerm = event.detail)}
            />
            <div className="content">
              {/* <AssetDetails asset={selectedAsset} type={assetType} /> */}
              <Grid
                searchTerm={this.state.searchTerm}
                entries={searchResults.entries}
                totalCount={searchResults.totalCount}
                tableColumns={GRID_COLUMNS}
                thumbnailMapper={ASSET_THUMBNAIL_MAPPER}
                displayMode={Grid.DISPLAY_MODE_THUMBNAIL_GRID}
                onScrollBottom={this._loadMoreSearchResults}
                // hidden={selectedAsset}
                onAddToCart={this._handleAddToCart}
                currentUser={this.props.currentUser}
              />
            </div>
          </section>
        ) : null}
      </div>
    );
  }

  componentWillUnmount() {
    //Clear the time out for loader
    this.clearTimer();
  }
}

export default withRouter(AssetsView);
